<template>
  <div :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <div class="px-2 py-8 xl:py-10 max-w-4xl mx-auto text-NotoSansRegular">
      <div class="mx-auto min-h-50">
        <div class="wishlist-content">
          <div class="w-full mb-4">
            <h3 class="mb-4 font-bold text-lg textColorDarkBlack text-center">我的收藏清單 ({{ countOfWish }})</h3>
          </div>
        </div>

        <div class="w-full text-center" v-if="wishList !== null && wishList.length > 0">
          <table class="rwd-table cart-table w-full mb-8">
            <thead class="">
              <tr class="w-full text-sm whitespace-no-wrap border-t border-b textColorDarkBlack">
                <th class="w-6/13 px-4 py-2">商品資訊</th>
                <th class="w-1/13 px-4 py-2">原價</th>
                <th class="w-1/13 px-4 py-2">折扣價</th>
                <th class="w-1/13 px-4 py-2">刪除</th>
                <th class="w-1/13 px-4 py-2">變更</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-sm border-b textColorDarkBlack"  v-for="(item, index) in wishList" :key="index">
                <td class="sm:px-4 py-4">
                  <div class="flex items-center">
                    <div class="mr-1">
                      <a class="itemImg cursor-pointer" @click="routeChange(item.id, item.type)">
                        <img v-if="item.cover !== ''" class="w-24 sm:w-32 h-24 object-contain" :src="item.cover" :alt="item.name" :title="item.name">
                        <img v-if="item.cover === ''" class="w-24 sm:w-32 h-24 object-contain" src="~@/assets/images/preset_item.png" :alt="item.name" :title="item.name">
                      </a>
                    </div>
                    <div class="text-left flex flex-col textColorDarkBlack">
                      <p class="sm:mb-1">
                        <span v-if="item.type === 'MAGAZINE'">雜誌</span>
                        <span v-if="item.type === 'SUBSCRIPTION' || item.type === 'PLAN'">雜誌訂閱</span>
                        <span v-if="item.type === 'BOOK'">叢書</span>
                        <span v-if="item.type === 'PACKAGE'">套書</span>
                        <span v-if="item.type === 'ITEM'">商品</span>
                      </p>
                      <div class="mb-1">
                        <a @click="routeChange(item.id, item.type)" class="cursor-pointer">
                          <p class="font-bold">{{ item.name }}</p>
                        </a>
                      </div>
                      <div v-if="item.event">
                        <a :href="item.event.url">
                          <p class="">
                            <span class="px-1 mr-1">(活動)</span>
                            <span class="">{{ item.event.name }}</span>
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="text-center py-3">
                  <span>原價</span>
                  <p v-if="item.type === 'SUBSCRIPTION' || item.type === 'PLAN'">--</p>
                  <p v-else>{{ item.fixed_price }}</p>
                </td>
                <td class="text-center py-3">
                  <span>折扣價</span>
                  <p v-if="item.type === 'SUBSCRIPTION' || item.type === 'PLAN'">--</p>
                  <p v-else>{{ item.pricing }}</p>
                </td>
                <td class="text-center py-3 cursor-pointer">
                  <span>刪除</span>
                  <a @click="removeItem(item.id)" class="px-3 py-2 md:px-5 md:py-3">
                    <font-awesome-icon icon="times" />
                  </a>
                </td>
                <td class="text-center py-3">
                  <span>加入購物車</span>
                  <button class="cursor-pointer text-NotoSansRegular py-1 px-3 rounded text-sm addCartBtn hidden lg:inline-block focus:outline-none"
                    type="button" @click="addCartItem(item)" v-if="item.in_stock > 0">
                    加入購物車
                  </button>
                  <a @click="addCartItem(item)" class="px-3 py-2 md:px-5 md:py-3 lg:hidden" v-if="item.in_stock > 0">
                    <font-awesome-icon icon="heart" />
                  </a>
                  <p v-if="item.in_stock < 1" class="text-sm">補貨中</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <img src="~@/assets/icon/Pulse.gif" class="mx-auto h-12 mt-12" v-if="wishList === null">

        <div class="w-full text-center mt-8 md:mt-12">
          <button class="button-red py-2 px-8 rounded text-white text-NotoSansRegular" @click="continueShopping">
            繼續訂購
          </button>
        </div>
      </div>
      <img src="~@/assets/icon/Pulse.gif" class="h-12 mt-12 fixed loading-img" v-if="isLoading">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Cart from '@/components/modules/addCart'
import axios from 'axios'
export default {
  name: 'WishList',
  data () {
    return {
      wishList: null,
      isLoading: false
    }
  },
  components: {
  },
  mixins: [
    Cart
  ],
  computed: {
    ...mapGetters([
      'authorized'
    ]),
    countOfWish () {
      let self = this
      if (self.wishList) {
        return self.wishList.length
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.checkAuthorized()
    this.getWishList()
  },
  updated () {
  },
  methods: {
    getWishList () {
      let self = this
      axios.get('/user/favorites')
        .then((response) => {
          self.$nextTick(() => {
            self.wishList = response.data.data
          })
          self.viewWishCode(response.data.data)
        })
    },
    continueShopping () {
      this.$router.push({ name: 'index' })
    },
    removeItem (id) {
      let self = this
      self.isLoading = true

      axios.delete(`/products/${id}/favorite`)
        .then(() => {
          self.getWishList()
        })
        .then(() => {
          self.isLoading = false
        })
    },
    async addCartItem (item) {
      let self = this
      if (item.type === 'PLAN') {
        await self.$router.push({ name: 'detail', params: { category: 'magazine', id: item.id } })
      } else {
        // await this.addShoppingList(plan)
        this.addMultipleToCart([item])
        self.removeItem(item.id)
      }
    },
    routeChange (id, type) {
      let self = this
      if (type === 'PACKAGE' || type === 'ITEM') {
        // 套書
        self.$router.push({ name: 'detail', params: { category: 'package', id: id } })
      } else if (type === 'BOOK') {
        // 叢書
        self.$router.push({ name: 'detail', params: { category: 'book', id: id } })
      } else if (type === 'MAGAZINE' || type === 'PLAN') {
        // 雜誌
        self.$router.push({ name: 'detail', params: { category: 'magazine', id: id } })
      }
    },
    checkAuthorized () {
      let self = this
      if (!self.authorized) {
        self.$router.push({ name: 'login' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.loading-img {
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 11;
}
.addCartBtn {
  border: 1px solid #9c9c9c;
  transition: .3s;
  color: #434343;
  background-color: white;
  &:hover {
    color: white;
    background-color: #9c9c9c;
  }
}
.cart-table td>span {
    display: none;
}
@media (max-width: 1024px) {
  .cart-table thead tr {
    display: none;
  }
  .cart-table tr>td:first-child {
      width: 100%;
  }
  .cart-table tr {
      display: block;
  }
  .cart-table td:nth-child(2), td:nth-child(3), td:nth-child(4), td:nth-child(5), td:nth-child(6), td:nth-child(7) {
      width: 25%;
      text-align: center;
  }
  .cart-table td {
      display: inline-block;
      vertical-align: top;
      font-size: 13px;
    }
  .cart-table td>span {
      display: block;
      margin-bottom: 12px;
      color: #000;
  }
  .cart-table td>span {
      display: block;
      margin-bottom: 12px;
      color: #000;
  }
}
</style>
